// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { changePasswordStyles } from "@guestsupply/Overrides/Widgets/ChangePassword/ChangePassword";
import { xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

changePasswordStyles.actions = {
    css: css`
        width: 100%;
    `,
};

changePasswordStyles.passwordGridContainer = {
    gap: 20,
    css: css`
        width: 50%;
        margin: 0;
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};

changePasswordStyles.passwordRequirementsGridContainer = {
    gap: 2,
    css: css`
        margin-bottom: 10px;
    `,
};

changePasswordStyles.passwordRequirementsGridItem = {
    width: 12,
};

changePasswordStyles.showPasswordsGridItem = {
    width: 12,
};

changePasswordStyles.userInformationGridItem = {
    width: 12,
};

changePasswordStyles.changePasswordLink = {
    css: css`
        margin-left: 10px;
    `,
};

changePasswordStyles.signOutWarningText = {
    css: css`
        padding-bottom: 10px;
        display: block;
    `,
};

changePasswordStyles.userInformationTitle = {
    variant: "h4",
    as: "h2",
};

changePasswordStyles.spinner = {
    css: css`
        margin: auto;
    `,
};

changePasswordStyles.centeringWrapper = {
    css: css`
        height: 150px;
        display: flex;
        align-items: center;
    `,
};

changePasswordStyles.userInformationTitleGridItem = {
    variant: "h4",
    css: css`
        margin-bottom: 0;
    `,
};

changePasswordStyles.passwordCriteria = {
    css: css`
        line-height: 24px;
    `,
};
